import { Component, Input, OnInit, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import { ObjInterface } from '@support/api/common/api-response.interface';
import { BANNER_CLASS } from './../../constants/widgets.constants';

@Component({
  selector: 'tmo-junk-fee-banner',
  templateUrl: './junk-fee-banner.component.html',
})
export class JunkFeeBannerComponent implements OnInit {
  @Input() public aemContent: ConfigData;
  public isAuthFlow: boolean;
  public showConnect: boolean;
  public junkFeeData: ObjInterface;
  public bannerClass = BANNER_CLASS;

  constructor(
    private stateStoreUtilService: StateStoreUtilsService,
    private objectService: ObjectService,
    private commonUtilService: CommonUtilService,
    private sanitizer: DomSanitizer
  ) {}

  public ngOnInit(): void {
    this.isAuthFlow = !!this.stateStoreUtilService.getAuthCustomerId();
    this.showConnect = document.cookie.includes('brand=connect');
    this.junkFeeData = this.getJunkFeeData();
  }

  public getJunkFeeData(): ObjInterface {
    let junkFeeData;
    if (
      this.isAuthFlow &&
      this.aemContent.showAuthBanner &&
      JSON.parse(this.aemContent.showAuthBanner)
    ) {
      const bannerContentAuth = JSON.parse(this.aemContent.bannerContentAuth);
      junkFeeData = {
        bannerIcon: this.sanitizer.bypassSecurityTrustHtml(
          this.objectService.get(bannerContentAuth, 'icon', '')
        ),
        bannerText: this.sanitizer.bypassSecurityTrustHtml(
          this.objectService.get(bannerContentAuth, 'content', '')
        ),
        isAction: this.objectService.get(bannerContentAuth, 'isAction', false),
        actionContent: this.sanitizer.bypassSecurityTrustHtml(
          this.objectService.get(bannerContentAuth, 'actionContent', '')
        ),
      };
    } else {
      if (
        this.showConnect &&
        this.aemContent.showConnectBanner &&
        JSON.parse(this.aemContent.showConnectBanner)
      ) {
        const bannerContentConnect = JSON.parse(this.aemContent.bannerContentConnect);
        junkFeeData = {
          bannerIcon: this.sanitizer.bypassSecurityTrustHtml(
            this.objectService.get(bannerContentConnect, 'icon', '')
          ),
          bannerText: this.sanitizer.bypassSecurityTrustHtml(
            this.objectService.get(bannerContentConnect, 'content', '')
          ),
          isAction: this.objectService.get(bannerContentConnect, 'isAction', false),
          actionContent: this.sanitizer.bypassSecurityTrustHtml(
            this.objectService.get(bannerContentConnect, 'actionContent', '')
          ),
        };
      } else if (
        !this.showConnect &&
        this.aemContent.showPrepaidBanner &&
        JSON.parse(this.aemContent.showPrepaidBanner)
      ) {
        const bannerContentPrepaid = JSON.parse(this.aemContent.bannerContentPrepaid);
        junkFeeData = {
          bannerIcon: this.sanitizer.bypassSecurityTrustHtml(
            this.objectService.get(bannerContentPrepaid, 'icon', '')
          ),
          bannerText: this.sanitizer.bypassSecurityTrustHtml(
            this.objectService.get(bannerContentPrepaid, 'content', '')
          ),
          isAction: this.objectService.get(bannerContentPrepaid, 'isAction', false),
          actionContent: this.sanitizer.bypassSecurityTrustHtml(
            this.objectService.get(bannerContentPrepaid, 'actionContent', '')
          ),
        };
      }
    }
    return junkFeeData;
  }

  @HostListener('document:navigateToAction', [
    '$event',
    '$event.detail.url',
    '$event.detail.newTab',
  ])
  public navigateToAction(event: Event, url: string, newTab: string): void {
    if (url) {
      this.commonUtilService.routeToGivenUrl(url, newTab ? JSON.parse(newTab) : false);
    }
  }
}
